import { ServiceBookingModel } from '@xeetr/types/models'

export const ServiceColumn = (booking: ServiceBookingModel) =>
  booking.services?.map((service) => service.name).join(', ')
